import { render, staticRenderFns } from "./SlideFadeTransition.vue?vue&type=template&id=495414f0&scoped=true"
import script from "./SlideFadeTransition.vue?vue&type=script&lang=ts"
export * from "./SlideFadeTransition.vue?vue&type=script&lang=ts"
import style0 from "./SlideFadeTransition.vue?vue&type=style&index=0&id=495414f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495414f0",
  null
  
)

export default component.exports